import React from "react";
import notificationIcon from "../../img/Notification.svg"
import "./NotificationButton.css";

const NotificationButton = () => {

  return (
    <div className="notification-button">
      <img src={notificationIcon} alt="notification"></img>
      <div className="overlap-group-22">
        <div className="ellipse-463"></div>
      </div>
    </div>
  );
}

export default NotificationButton;
